import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./assets/css/styles.css";
import "./assets/css/colors.css";
import "./config.ts";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "react-hot-toast"; // <-- import

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <HelmetProvider>
    <BrowserRouter>
      <div id="main-wrapper">
        <App />
        <Toaster
          position="top-right"
          reverseOrder={false}
          toastOptions={{ style: { fontSize: "18px", textAlign: "center" } }}
        />
      </div>
    </BrowserRouter>
  </HelmetProvider>
);

reportWebVitals();
